import { render, staticRenderFns } from "./DesktopConfig.vue?vue&type=template&id=2841f477&scoped=true"
import script from "./DesktopConfig.vue?vue&type=script&lang=js"
export * from "./DesktopConfig.vue?vue&type=script&lang=js"
import style0 from "./DesktopConfig.vue?vue&type=style&index=0&id=2841f477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841f477",
  null
  
)

export default component.exports